
import { Options, Vue } from "vue-class-component"; //基本需要\

import roma from "../assets/json1/roma.js";
import * as echarts from "echarts";
import passion1 from "@/assets/js/passion1.js";
import { store } from "@/store"; //引入仓库
import { ElMessage } from "element-plus";
import {
  dateConversion,
  getLocalProject,
  saveLocalProject,
  saveLocalStorageProject,
  typeConversion,
} from "@/utils"; //类型
import {
  dispatchAndroidOfflineDate,
  dispatchAndroidOfflineDevice,
  dispatchAndroidAppDevice,
  dispatchAndroidAppScene,
  dispatchAndroidOfflineScenes,
  dispatchAndroidAppSubtype,
  dispatchAndroidOfflineSubtypes,
  dispatchAndroidOfflineList,
  dispatchAndroidThreadOptions,
  dispatchAndroidCourseOptions,
  dispatchAndroidThreadTrend,
  dispatchAndroidCourseTrend,
  dispatchAndroidCourseProcessList,
  dispatchAndroidThreadProcessList,
  dispatchAndroidAppLog,
  dispatchAndroidAppFileData,
  dispatchAndroidOfflineOldList,
  dispatchAndroidOfflineThreadOldList,
  dispatchAndroidThreadCompare,
  dispatchAndroidCourseCompare,
  dispatchAndroidOfflineZip,
  dispatchLightPerfDevice,
  dispatchLightPerfScene,
  dispatchLightPerfSubtype,
  dispatchLightPerfLog,
  dispatchLightResource,
  dispatchLightJank,
  dispatchLightMethod,
  dispatchAndroidOfflineOldDate,
  dispatchLightPerfTrend,
  dispatchLightPerfFunctions,
  dispatchLightPerfDateContrast,
  dispatchAndroidAppDateContrast,
  dispatchLightPerfResourceCost,
  dispatchLightPerfJankCost,
  dispatchLightPerfMethodCost,
  dispatchAndroidAppFileCompare,
  dispatchAndroidAppFilename,
  dispatchAndroidAppFileTrend,
  dispatchAndroidOfflineUrl,
  dispatchAndroidAppZip,
  dispatchDeleteOffline,
} from "@/store/performance/actions";
// import God from "@/assets/js/god.js";
import {
  readGetAndroidOfflineDevice,
  readGetAndroidOfflineDate,
  readGetAndroidOfflineDateOld,
  readGetAndroidOfflineScenes,
  readGetAndroidOfflineSubtypes,
  readGetAndroidOfflineList,
  readGetAndroidThreadOptions,
  readGetAndroidCourseOptions,
  readGetAndroidCourseTrend,
  readGetAndroidThreadTrend,
  readGetAndroidCourseProcessList,
  readGetAndroidThreadProcessList,
  readGetAndroidThreadCompare,
  readGetAndroidCourseCompare,
  readGetAndroidOfflineOldList,
  readGetAndroidOfflineThreadOldList,
  readGetAndroidOfflineOfflineZip,
  readGetAndroidOfflineOfflineUrl,
  readGetAndroidAppDevice,
  readGetAndroidAppScene,
  readGetAndroidAppSubtype,
  readGetAndroidAppLog,
  readGetLightPerfDevice,
  readGetAndroidAppFileTrend,
  readGetLightPerfScene,
  readGetLightPerfSubtype,
  readGetLightPerfLog,
  readGetAndroidAppFileData,
  readGetLightPerfResource,
  readGetLightPerfJank,
  readGetLightPerfMethod,
  readGetLightPerfFunctions,
  readGetLightPerfTrend,
  readGetAndroidAppFilename,
  readGetLightPerfDateContrast,
  readGetAndroidAppDateContrast,
  readGetLightPerfResourContrast,
  readGetLightPerfJankContrast,
  readGetLightPerfMethodContrast,
  readGetAndroidAppDateFileCompare,
  readGetAndroidAppZip,
} from "@/store/performance/getters";
export default class TestReport extends Vue {
  public localProject = Number(getLocalProject()); //得到本地的项目
  public ResourceTableLoading = false;
  public loading = false;
  public trendLoading = false;
  public courseTrendLoading = false;
  public threadTrendLoading = false;
  public threadTabelLoading = false;
  public courseCompareLoading = false;
  public threadCompareLoading = false;
  public get androidZip() {
    return readGetAndroidOfflineOfflineZip(store).file_path;
  }
  public get androidUrl() {
    return readGetAndroidOfflineOfflineUrl(store);
  }
  public get courseTable() {
    return readGetAndroidCourseProcessList(store);
  }
  public get threadTable() {
    return readGetAndroidThreadProcessList(store);
  }
  public getNum(newValue, oldValue) {
    if (newValue > oldValue) {
      return "(" + (newValue - oldValue) + "↑)";
    }
    if (newValue < oldValue) {
      return "(" + (oldValue - newValue) + "↓)";
    }
    if (newValue === oldValue) {
      return 0;
    }
  }
  public get threadCompare() {
    return readGetAndroidThreadCompare(store);
  }
  public get courseCompare() {
    return readGetAndroidCourseCompare(store);
  }
  public courseTableLoading = false;
  public async detailChange(type) {
    if (type == "course") {
      this.courseTrendLoading = true;
      // this.courseCurrentPage=1
      //    this.course_input=''
      await dispatchAndroidCourseTrend(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        type: 1,
        names: this.filterList.course,
        start: this.filterList.dateRange?.[0] || '',
        end: this.filterList.dateRange?.[1] || '',
      });
      await this.drawCourseTrend();
      //    await dispatchAndroidCourseProcessList(store, {
      //   project: this.localProject,
      //   id_test: Number(this.filterList.Journa),
      //   type: 1,
      //   search: "",
      //   size: this.courseSize,
      //   page: this.courseCurrentPage,
      // });
      this.courseTrendLoading = false;
    }

    if (type == "thread") {
      this.threadTrendLoading = true;
      await dispatchAndroidThreadTrend(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        type: 2,
        names: this.filterList.thread,
        start: this.filterList.threadDateRange?.[0] || '',
        end: this.filterList.threadDateRange?.[1] || '',
      });
      await this.drawThreadTrend();
      this.threadTrendLoading = false;
    }
  }
  public courseList = [
    "ite.sgameGlobal",
    "systeam_server",
    "main",
    "surfaceflinger",
    "kworker/u16:3",
  ];
  public threadList = [
    "UnityMain",
    "UnityGfx",
    "Worker",
    "Thread",
    "NativeThread",
    "CoreThread",
    "Thread-72",
    "INTLwork17",
    "INTLwork10",
    "UnityPreload",
  ];
  public async mounted() {
    // this.ResourceTableLoading = true;
    // this.loading = true;
    // this.trendLoading = true;
    // await dispatchLightPerfDate(store, {
    //   project: this.localProject,
    // });
    // await dispatchAndroidAppDate(store, {
    //   project: this.localProject,
    // });
    this.courseTableLoading = true;
    this.courseTrendLoading = true;
    this.threadTrendLoading = true;
    this.threadTabelLoading = true;
    this.courseCompareLoading = true;
    this.threadCompareLoading = true;
    await dispatchAndroidOfflineDate(store, {
      project: this.localProject,
    });
    // this.filterList.date = readGetAndroidAppDate(store)[0].date;
    this.filterList.date = readGetAndroidOfflineDate(store)[0].date;

    // await dispatchLightPerfDevice(store, {
    //   project: this.localProject,
    //   date: this.filterList.date,
    // });
    await dispatchAndroidOfflineDevice(store, {
      project: this.localProject,
      date: this.filterList.date,
    });

    const option = readGetAndroidOfflineDevice(store).find(item => item.name.includes('J200')) || readGetAndroidOfflineDevice(store)[0]
    this.filterList.device = option?.device_id;

    // await dispatchLightPerfScene(store, {
    //   project: this.localProject,
    //   date: this.filterList.date,
    //   device_id: Number(this.filterList.device),
    // });
    await dispatchAndroidOfflineScenes(store, {
      project: this.localProject,
      date: this.filterList.date,
      device_id: Number(this.filterList.device),
    });
    this.filterList.scene = readGetAndroidOfflineScenes(store)[0].id;
    await dispatchAndroidOfflineSubtypes(store, {
      project: this.localProject,
      date: this.filterList.date,
      device_id: Number(this.filterList.device),
      scene_id: Number(this.filterList.scene),
    });

    this.filterList.subtype = readGetAndroidOfflineSubtypes(store)[0].subtype;
    await Promise.all([
      dispatchAndroidOfflineList(store, {
        project: this.localProject,
        date: this.filterList.date,
        device_id: Number(this.filterList.device),
        scene_id: Number(this.filterList.scene),
        subtype: '',
        //subtype: Number(this.filterList.subtype),
      }),

      dispatchAndroidOfflineOldDate(store, {
        project: this.localProject,
        device_id: Number(this.filterList.device),
        scene_id: Number(this.filterList.scene),
        subtype: '',
        //subtype: Number(this.filterList.subtype),
      }),
    ]);
    if (readGetAndroidOfflineDateOld(store).length > 1) {
      this.filterList.old_date = readGetAndroidOfflineDateOld(store)[1].date;
      this.filterList.old_thread_date = readGetAndroidOfflineDateOld(
        store
      )[1].date;
    } else {
      this.filterList.old_date = readGetAndroidOfflineDateOld(store)[0].date;
      this.filterList.old_thread_date = readGetAndroidOfflineDateOld(
        store
      )[0].date;
    }

    await dispatchAndroidOfflineOldList(store, {
      project: this.localProject,
      date: this.filterList.old_date,
      device_id: Number(this.filterList.device),
      scene_id: Number(this.filterList.scene),
      subtype: '',
      //subtype: Number(this.filterList.subtype),
    }),
      await dispatchAndroidOfflineThreadOldList(store, {
        project: this.localProject,
        date: this.filterList.old_thread_date,
        device_id: Number(this.filterList.device),
        scene_id: Number(this.filterList.scene),
        subtype: '',
        //subtype: Number(this.filterList.subtype),
      });
    if (readGetAndroidOfflineOldList(store).length > 1) {
      this.filterList.old_Journa = readGetAndroidOfflineOldList(
        store
      )[1].id_test;
    } else {
      this.filterList.old_Journa = readGetAndroidOfflineOldList(store)[0]
        ?.id_test
        ? readGetAndroidOfflineOldList(store)[0]?.id_test
        : "";
    }
    if (readGetAndroidOfflineThreadOldList(store).length > 1) {
      this.filterList.old_thread_Journa = readGetAndroidOfflineThreadOldList(
        store
      )[1].id_test;
    } else {
      this.filterList.old_thread_Journa = readGetAndroidOfflineThreadOldList(
        store
      )[0]?.id_test
        ? readGetAndroidOfflineThreadOldList(store)[0]?.id_test
        : "";
    }
    this.filterList.Journa = readGetAndroidOfflineList(store)[0].id_test;
    // this.filterList.old_thread_Journa = readGetAndroidOfflineThreadOldList(store)[0].id_test;
    await Promise.all([
      dispatchAndroidOfflineZip(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
      }),
      dispatchAndroidOfflineUrl(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
      }),
      dispatchAndroidThreadOptions(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        type: 2,
      }),
      await dispatchAndroidCourseOptions(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        type: 1,
      }),
    ]);

    let courseCreated = [];
    let threadCreated = [];
    this.courseOptins.forEach((v) => {
      this.courseList.forEach((k) => {
        if (v.name === k) {
          courseCreated.push(k);
        }
      });
    });
    this.threadOptins.forEach((v) => {
      this.threadList.forEach((k) => {
        if (v.name === k) {
          threadCreated.push(k);
        }
      });
    });

    this.filterList.course = courseCreated;
    courseCreated;

    this.filterList.thread = threadCreated;
    threadCreated;

    await dispatchAndroidCourseTrend(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      type: 1,
      names: this.filterList.course,
    });
    await dispatchAndroidThreadTrend(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      type: 2,
      names: this.filterList.thread,
    });
    await this.drawCourseTrend();
    await this.drawThreadTrend();
    this.courseTrendLoading = false;
    this.threadTrendLoading = false;
    await dispatchAndroidCourseProcessList(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      type: 1,
      search: "",
      size: this.courseSize,
      page: this.courseCurrentPage,
    });
    await dispatchAndroidThreadProcessList(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      type: 2,
      search: "",
      size: this.threadSize,
      page: this.threadCurrentPage,
    });
    this.courseTableLoading = false;
    this.threadTabelLoading = false;

    await dispatchAndroidThreadCompare(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      type: 2,
      old_test: this.filterList.old_thread_Journa
        ? Number(this.filterList.old_thread_Journa)
        : "",
    });
    await dispatchAndroidCourseCompare(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      type: 1,
      old_test: this.filterList.old_Journa
        ? Number(this.filterList.old_Journa)
        : "",
    });
    this.courseCompareLoading = false;
    this.threadCompareLoading = false;
  }
  public get resourceList() {
    return readGetAndroidAppDateFileCompare(store);
  }
  public get methodList() {
    return readGetLightPerfMethodContrast(store);
  }
  public get jankList() {
    return readGetLightPerfJankContrast(store);
  }
  public async compareChange(name, type) {
    if (name == "course") {
      if (type === true) {
        await dispatchAndroidOfflineOldList(store, {
          project: this.localProject,
          date: this.filterList.old_date,
          device_id: Number(this.filterList.device),
          scene_id: Number(this.filterList.scene),
          subtype: '',
          //subtype: Number(this.filterList.subtype),
        });
        if (readGetAndroidOfflineOldList(store).length > 1) {
          this.filterList.old_Journa = readGetAndroidOfflineOldList(
            store
          )[1].id_test;
        } else {
          this.filterList.old_Journa = readGetAndroidOfflineOldList(store)[0]
            ?.id_test
            ? readGetAndroidOfflineOldList(store)[0]?.id_test
            : "";
        }
      } else {
        this.courseCompareLoading = true;
        this.courseCompareCurrentPage = 1;
        await dispatchAndroidCourseCompare(store, {
          project: this.localProject,
          id_test: Number(this.filterList.Journa),
          type: 1,
          old_test: this.filterList.old_Journa
            ? Number(this.filterList.old_Journa)
            : "",
        });
        this.courseCompareLoading = false;
      }
    }
    if (name === "thread") {
      if (type == true) {
        await dispatchAndroidOfflineThreadOldList(store, {
          project: this.localProject,
          date: this.filterList.old_thread_date,
          device_id: Number(this.filterList.device),
          scene_id: Number(this.filterList.scene),
          subtype: '',
          //subtype: Number(this.filterList.subtype),
        });
        if (readGetAndroidOfflineThreadOldList(store).length > 1) {
          this.filterList.old_thread_Journa = readGetAndroidOfflineThreadOldList(
            store
          )[1].id_test;
        } else {
          this.filterList.old_thread_Journa = readGetAndroidOfflineThreadOldList(
            store
          )[0]?.id_test
            ? readGetAndroidOfflineThreadOldList(store)[0]?.id_test
            : "";
        }
      } else {
        this.threadCompareCurrentPage = 1;
        this.threadCompareLoading = true;
        await dispatchAndroidThreadCompare(store, {
          project: this.localProject,
          id_test: Number(this.filterList.Journa),
          type: 2,
          old_test: this.filterList.old_thread_Journa
            ? Number(this.filterList.old_thread_Journa)
            : "",
        });
        this.threadCompareLoading = false;
      }
    }
  }
  public async cost(type) {
    this.ResourceTableLoading = true;
    if (type === "jank") {
      this.currentPage6 = 1;
      await dispatchLightPerfJankCost(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        date_list: this.filterList.dateJank,
      });
      this.JankTable.results = this.jankList.list.slice(
        (this.currentPage6 - 1) * 10,
        this.currentPage6 * 10
      );
    }
    if (type === "resource") {
      this.currentPage4 = 1;
      await dispatchAndroidAppFileCompare(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        date_list: this.filterList.dateResource,
      });
      this.ResourceTable.results = this.resourceList.list.slice(
        (this.currentPage4 - 1) * 10,
        this.currentPage4 * 10
      );
    }
    if (type === "method") {
      this.currentPage5 = 1;
      await dispatchLightPerfMethodCost(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        date_list: this.filterList.dateMethod,
      });
      this.MethodTable.results = this.methodList.list.slice(
        (this.currentPage5 - 1) * 10,
        this.currentPage5 * 10
      );
    }
    this.ResourceTableLoading = false;
  }
  public ResourceTable: any = {
    results: [],
    count: 0,
  };
  public MethodTable: any = {
    results: [],
    count: 0,
  };
  public packageBtn() {
    if (this.androidUrl === "") {
      ElMessage.error("无对应的流水线");
    } else {
      window.open(this.androidUrl, "_blank");
    }
  }
  public JankTable: any = {
    results: [],
    count: 0,
  };
  public get appZip() {
    return readGetAndroidAppZip(store);
  }
  public resource_input = "";
  public jank_input = "";
  public method_input = "";
  public course_input = "";
  public thread_input = "";
  public record = 10;
  public courseCurrentPage = 1;
  public courseSize = 60;
  public threadCurrentPage = 1;
  public threadSize = 60;
  public courseCompareSize = 20;

  public threadCompareSize = 20;
  public threadCompareCurrentPage = 1;
  public courseCompareCurrentPage = 1;
  public currentPage1 = 1;
  public currentPage2 = 1;
  public currentPage3 = 1;
  public currentPage4 = 1;
  public currentPage5 = 1;
  public currentPage6 = 1;
  public filterList = {
    date: "",
    device: "",
    scene: "",
    subtype: "",
    Journa: "",
    old_Journa: "",
    old_thread_date: "",
    old_thread_Journa: "",
    trendOp: "",
    thread: [],
    course: [],
    dateResource: [],
    dateMethod: [],
    dateJank: [],
    old_date: "",
    dateRange: [],
    threadDateRange: [],
  };
  public async deleteBtn() {
    await dispatchDeleteOffline(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
    });
    this.courseTableLoading = true;
    this.courseTrendLoading = true;
    this.threadTrendLoading = true;
    this.threadTabelLoading = true;
    this.courseCompareLoading = true;
    this.threadCompareLoading = true;
    await dispatchAndroidOfflineDate(store, {
      project: this.localProject,
    });
    // this.filterList.date = readGetAndroidAppDate(store)[0].date;
    this.filterList.date = readGetAndroidOfflineDate(store)[0].date;

    // await dispatchLightPerfDevice(store, {
    //   project: this.localProject,
    //   date: this.filterList.date,
    // });
    await dispatchAndroidOfflineDevice(store, {
      project: this.localProject,
      date: this.filterList.date,
    });
    this.filterList.device = readGetAndroidOfflineDevice(store)[0].device_id;
    // await dispatchLightPerfScene(store, {
    //   project: this.localProject,
    //   date: this.filterList.date,
    //   device_id: Number(this.filterList.device),
    // });
    await dispatchAndroidOfflineScenes(store, {
      project: this.localProject,
      date: this.filterList.date,
      device_id: Number(this.filterList.device),
    });
    this.filterList.scene = readGetAndroidOfflineScenes(store)[0].id;
    await dispatchAndroidOfflineSubtypes(store, {
      project: this.localProject,
      date: this.filterList.date,
      device_id: Number(this.filterList.device),
      scene_id: Number(this.filterList.scene),
    });

    this.filterList.subtype = readGetAndroidOfflineSubtypes(store)[0].subtype;
    await Promise.all([
      dispatchAndroidOfflineList(store, {
        project: this.localProject,
        date: this.filterList.date,
        device_id: Number(this.filterList.device),
        scene_id: Number(this.filterList.scene),
        subtype: '',
        //subtype: Number(this.filterList.subtype),
      }),

      dispatchAndroidOfflineOldDate(store, {
        project: this.localProject,
        device_id: Number(this.filterList.device),
        scene_id: Number(this.filterList.scene),
        subtype: '',
        //subtype: Number(this.filterList.subtype),
      }),
    ]);
    if (readGetAndroidOfflineDateOld(store).length > 1) {
      this.filterList.old_date = readGetAndroidOfflineDateOld(store)[1].date;
      this.filterList.old_thread_date = readGetAndroidOfflineDateOld(
        store
      )[1].date;
    } else {
      this.filterList.old_date = readGetAndroidOfflineDateOld(store)[0].date;
      this.filterList.old_thread_date = readGetAndroidOfflineDateOld(
        store
      )[0].date;
    }

    await dispatchAndroidOfflineOldList(store, {
      project: this.localProject,
      date: this.filterList.old_date,
      device_id: Number(this.filterList.device),
      scene_id: Number(this.filterList.scene),
      subtype: '',
      //subtype: Number(this.filterList.subtype),
    }),
      await dispatchAndroidOfflineThreadOldList(store, {
        project: this.localProject,
        date: this.filterList.old_thread_date,
        device_id: Number(this.filterList.device),
        scene_id: Number(this.filterList.scene),
        subtype: '',
        //subtype: Number(this.filterList.subtype),
      });
    if (readGetAndroidOfflineOldList(store).length > 1) {
      this.filterList.old_Journa = readGetAndroidOfflineOldList(
        store
      )[1].id_test;
    } else {
      this.filterList.old_Journa = readGetAndroidOfflineOldList(store)[0]
        ?.id_test
        ? readGetAndroidOfflineOldList(store)[0]?.id_test
        : "";
    }
    if (readGetAndroidOfflineThreadOldList(store).length > 1) {
      this.filterList.old_thread_Journa = readGetAndroidOfflineThreadOldList(
        store
      )[1].id_test;
    } else {
      this.filterList.old_thread_Journa = readGetAndroidOfflineThreadOldList(
        store
      )[0]?.id_test
        ? readGetAndroidOfflineThreadOldList(store)[0]?.id_test
        : "";
    }
    this.filterList.Journa = readGetAndroidOfflineList(store)[0].id_test;
    // this.filterList.old_thread_Journa = readGetAndroidOfflineThreadOldList(store)[0].id_test;
    await Promise.all([
      dispatchAndroidOfflineZip(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
      }),
      dispatchAndroidOfflineUrl(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
      }),
      dispatchAndroidThreadOptions(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        type: 2,
      }),
      await dispatchAndroidCourseOptions(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        type: 1,
      }),
    ]);

    let courseCreated = [];
    let threadCreated = [];
    this.courseOptins.forEach((v) => {
      this.courseList.forEach((k) => {
        if (v.name === k) {
          courseCreated.push(k);
        }
      });
    });
    this.threadOptins.forEach((v) => {
      this.threadList.forEach((k) => {
        if (v.name === k) {
          threadCreated.push(k);
        }
      });
    });

    this.filterList.course = courseCreated;
    courseCreated;

    this.filterList.thread = threadCreated;
    threadCreated;

    await dispatchAndroidCourseTrend(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      type: 1,
      names: this.filterList.course,
    });
    await dispatchAndroidThreadTrend(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      type: 2,
      names: this.filterList.thread,
    });
    await this.drawCourseTrend();
    await this.drawThreadTrend();
    this.courseTrendLoading = false;
    this.threadTrendLoading = false;
    this.courseCurrentPage = 1;
    this.threadCurrentPage = 1;
    this.course_input = "";
    this.thread_input = "";
    await dispatchAndroidCourseProcessList(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      type: 1,
      search: "",
      size: this.courseSize,
      page: this.courseCurrentPage,
    });
    await dispatchAndroidThreadProcessList(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      type: 2,
      search: "",
      size: this.threadSize,
      page: this.threadCurrentPage,
    });
    this.courseTableLoading = false;
    this.threadTabelLoading = false;

    await dispatchAndroidThreadCompare(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      type: 2,
      old_test: this.filterList.old_thread_Journa
        ? Number(this.filterList.old_thread_Journa)
        : "",
    });
    await dispatchAndroidCourseCompare(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      type: 1,
      old_test: this.filterList.old_Journa
        ? Number(this.filterList.old_Journa)
        : "",
    });
    this.courseCompareLoading = false;
    this.threadCompareLoading = false;
  }
  public async recordSearch(type) {
    if (type === "course_input") {
      this.courseTableLoading = true;
      this.courseCurrentPage = 1;
      await dispatchAndroidCourseProcessList(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        type: 1,
        search: this.course_input,
        size: this.courseSize,
        page: this.courseCurrentPage,
      });
      this.courseTableLoading = false;
    }
    if (type === "thread_input") {
      this.threadTabelLoading = true;
      this.threadCurrentPage = 1;
      await dispatchAndroidThreadProcessList(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        type: 2,
        search: this.thread_input,
        size: this.threadSize,
        page: this.threadCurrentPage,
      });
      this.threadTabelLoading = false;
    }
    // if (type === "resource_input") {
    //   this.currentPage1 = 1;
    //   await dispatchAndroidAppFileData(store, {
    //     project: this.localProject,
    //     id_test: Number(this.filterList.Journa),
    //     search: this.resource_input,
    //     size: this.record,
    //     page: this.currentPage1,
    //   });
    // }
    // if (type === "jank_input") {
    //   this.currentPage2 = 1;
    //   await dispatchLightJank(store, {
    //     project: this.localProject,
    //     id_test: Number(this.filterList.Journa),
    //     search: this.jank_input,
    //     size: this.record,
    //     page: this.currentPage2,
    //   });
    // }
    // if (type === "method_input") {
    //   this.currentPage3 = 1;
    //   await dispatchLightMethod(store, {
    //     project: this.localProject,
    //     id_test: Number(this.filterList.Journa),
    //     search: this.method_input,
    //     size: this.record,
    //     page: this.currentPage3,
    //   });
    // }
    this.loading = false;
  }
  public async handleCurrentChange1(type) {
    this.ResourceTableLoading = true;
    if (type === "resource_input") {
      this.ResourceTable.results = this.resourceList.list.slice(
        (this.currentPage4 - 1) * 10,
        this.currentPage4 * 10
      );
    }
    if (type === "jank_input") {
      this.JankTable.results = this.jankList.list.slice(
        (this.currentPage6 - 1) * 10,
        this.currentPage6 * 10
      );
    }
    if (type === "method_input") {
      this.MethodTable.results = this.methodList.list.slice(
        (this.currentPage5 - 1) * 10,
        this.currentPage5 * 10
      );
    }
    this.ResourceTableLoading = false;
  }
  public async onSearch(type) {
    if (type == "course") {
      this.courseCurrentPage = 1;
      await dispatchAndroidCourseProcessList(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        type: 1,
        search: this.course_input,
        size: this.courseSize,
        page: this.courseCurrentPage,
      });
    }
    if (type == "thread") {
      this.threadCurrentPage = 1;
      await dispatchAndroidThreadProcessList(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        type: 2,
        search: this.thread_input,
        size: this.threadSize,
        page: this.threadCurrentPage,
      });
    }
    if (type == "threadCompare") {
      this.threadCompareCurrentPage = 1;
    }
    if (type === "courseCompare") {
      this.courseCompareCurrentPage = 1;
    }
  }
  public async handleCurrentChange(type) {
    this.loading = true;
    if (type == "course") {
      await dispatchAndroidCourseProcessList(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        type: 1,
        search: this.course_input,
        size: this.courseSize,
        page: this.courseCurrentPage,
      });
    }
    if (type == "thread") {
      await dispatchAndroidThreadProcessList(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        type: 2,
        search: this.thread_input,
        size: this.threadSize,
        page: this.threadCurrentPage,
      });
    }
    if (type === "resource_input") {
      await dispatchAndroidAppFileData(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        search: this.resource_input,
        size: this.record,
        page: this.currentPage1,
      });
    }
    if (type === "jank_input") {
      await dispatchLightJank(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        search: this.jank_input,
        size: this.record,
        page: this.currentPage2,
      });
    }
    if (type === "method_input") {
      await dispatchLightMethod(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        search: this.method_input,
        size: this.record,
        page: this.currentPage3,
      });
    }
    this.loading = false;
  }
  public get dateOptions() {
    return readGetAndroidOfflineDate(store);
  }
  public get dateOptionsOld() {
    return readGetAndroidOfflineDateOld(store);
  }
  public get deviceOptions() {
    return readGetAndroidOfflineDevice(store);
  }
  public get sceneOptions() {
    return readGetAndroidOfflineScenes(store);
  }
  public get subtypeOptions() {
    return readGetAndroidOfflineSubtypes(store);
  }
  public get JournaOptions() {
    return readGetAndroidOfflineList(store);
  }
  public get JournaOptionsOld() {
    return readGetAndroidOfflineOldList(store);
  }
  public get JournaOptionsThreadOld() {
    return readGetAndroidOfflineThreadOldList(store);
  }
  public get lightPerfResource() {
    return readGetAndroidAppFileData(store);
  }
  public get threadOptins() {
    return readGetAndroidThreadOptions(store);
  }
  public get courseOptins() {
    return readGetAndroidCourseOptions(store);
  }
  // public get lightPerfJank() {
  //   return readGetLightPerfJank(store);
  // }
  // public get lightPerfmethod() {
  //   return readGetLightPerfMethod(store);
  // }
  public get lightPerfFunctions() {
    return readGetAndroidAppFilename(store);
  }
  public get lightPerfTrend() {
    return readGetAndroidAppFileTrend(store);
  }
  public get lightPerfDateContrast() {
    return readGetAndroidAppDateContrast(store);
  }
  public async allOption(item) {
    this.courseTrendLoading = true;
    this.threadTrendLoading = true;
    this.courseTableLoading = true;
    this.threadTabelLoading = true;
    for (let v of item) {
      if (v === "device") {
        await dispatchAndroidOfflineDevice(store, {
          project: this.localProject,
          date: this.filterList.date,
        });

        const defaultOption = readGetAndroidOfflineDevice(store).find(item => item.name.includes('J200')) || readGetAndroidOfflineDevice(store)[0]
        this.filterList.device = defaultOption?.device_id;
      }
      if (v === "scene") {
        await dispatchAndroidOfflineScenes(store, {
          project: this.localProject,
          date: this.filterList.date,
          device_id: Number(this.filterList.device),
        });
        this.filterList.scene = readGetAndroidOfflineScenes(store)[0].id;
      }
      if (v === "subtype") {
        await dispatchAndroidOfflineSubtypes(store, {
          project: this.localProject,
          date: this.filterList.date,
          device_id: Number(this.filterList.device),
          scene_id: Number(this.filterList.scene),
        });

        this.filterList.subtype = readGetAndroidOfflineSubtypes(
          store
        )[0].subtype;
      }
      if (v === "log") {
        await dispatchAndroidOfflineList(store, {
          project: this.localProject,
          date: this.filterList.date,
          device_id: Number(this.filterList.device),
          scene_id: Number(this.filterList.scene),
          subtype: '',
          //subtype: Number(this.filterList.subtype),
        });
        await dispatchAndroidOfflineOldList(store, {
          project: this.localProject,
          date: this.filterList.old_date,
          device_id: Number(this.filterList.device),
          scene_id: Number(this.filterList.scene),
          subtype: '',
          //subtype: Number(this.filterList.subtype),
        });

        await dispatchAndroidOfflineThreadOldList(store, {
          project: this.localProject,
          date: this.filterList.old_thread_date,
          device_id: Number(this.filterList.device),
          scene_id: Number(this.filterList.scene),
          subtype: '',
          //subtype: Number(this.filterList.subtype),
        });
        if (readGetAndroidOfflineOldList(store).length > 1) {
          this.filterList.old_Journa = readGetAndroidOfflineOldList(
            store
          )[1].id_test;
        } else {
          this.filterList.old_Journa = readGetAndroidOfflineOldList(store)[0]
            ?.id_test
            ? readGetAndroidOfflineOldList(store)[0]?.id_test
            : "";
        }
        if (readGetAndroidOfflineThreadOldList(store).length > 1) {
          this.filterList.old_thread_Journa = readGetAndroidOfflineThreadOldList(
            store
          )[1].id_test;
        } else {
          this.filterList.old_thread_Journa = readGetAndroidOfflineThreadOldList(
            store
          )[0]?.id_test
            ? readGetAndroidOfflineThreadOldList(store)[0]?.id_test
            : "";
        }

        this.filterList.Journa = readGetAndroidOfflineList(store)[0].id_test;
      }
      await dispatchAndroidOfflineZip(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
      }),
        await dispatchAndroidOfflineUrl(store, {
          project: this.localProject,
          id_test: Number(this.filterList.Journa),
        }),
        await dispatchAndroidThreadOptions(store, {
          project: this.localProject,
          id_test: Number(this.filterList.Journa),
          type: 2,
        });
      await dispatchAndroidCourseOptions(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        type: 1,
      });
      let courseCreated = [];
      let threadCreated = [];
      this.courseOptins.forEach((v) => {
        this.courseList.forEach((k) => {
          if (v.name === k) {
            courseCreated.push(k);
          }
        });
      });
      this.threadOptins.forEach((v) => {
        this.threadList.forEach((k) => {
          if (v.name === k) {
            threadCreated.push(k);
          }
        });
      });
      this.filterList.course = courseCreated;
      courseCreated;

      this.filterList.thread = threadCreated;
      threadCreated;
      await dispatchAndroidCourseTrend(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        type: 1,
        names: this.filterList.course,
      });
      await dispatchAndroidThreadTrend(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        type: 2,
        names: this.filterList.thread,
      });
    }
    await this.drawCourseTrend();
    await this.drawThreadTrend();
    this.courseTrendLoading = false;
    this.threadTrendLoading = false;
    this.courseCurrentPage = 1;
    this.threadCurrentPage = 1;
    this.course_input = "";
    this.thread_input = "";
    await dispatchAndroidCourseProcessList(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      type: 1,
      search: "",
      size: this.courseSize,
      page: this.courseCurrentPage,
    });
    await dispatchAndroidThreadProcessList(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      type: 2,
      search: "",
      size: this.threadSize,
      page: this.threadCurrentPage,
    });
    this.courseTableLoading = false;
    this.threadTabelLoading = false;
    //    await dispatchAndroidThreadCompare(store,{
    //    project: this.localProject,
    //     id_test: Number(this.filterList.Journa),
    //     type: 2,
    //     old_test:Number(this.filterList.old_thread_Journa)
    // })
    // await dispatchAndroidCourseCompare(store,{
    //    project: this.localProject,
    //     id_test: Number(this.filterList.Journa),
    //     type: 1,
    //     old_test:Number(this.filterList.old_Journa)
    // })
  }
  // public  cellStyle({row, column, rowIndex, columnIndex}){
  //   console.log(column)
  //   //     if(rowIndex === 1 && columnIndex === 2){ //指定坐标rowIndex ：行，columnIndex ：列
  //   //     return 'background:red' //rgb(105,0,7)
  //   // }else{
  //   //     return ''
  //   // }
  //   }

  public getCom(newValue, oldValue) {
    if (newValue > oldValue) {
      return "(" + (newValue - oldValue) + "↓)";
    }
    if (newValue === oldValue) {
      return "(--)";
    }
    if (newValue < oldValue) {
      return "(" + (oldValue - newValue) + "↑)";
    }
  }
  public async allOption1() {
    this.trendLoading = true;
    await dispatchAndroidAppFileTrend(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      file_name: this.filterList.trendOp,
    });
    await this.drawTrend();
    this.trendLoading = false;
  }
  public get couseTrend() {
    return readGetAndroidCourseTrend(store);
  }
  public get threadTrend() {
    return readGetAndroidThreadTrend(store);
  }
  public percent = true;
  public percent1 = true;

  public drawThreadTrend() {
    let ordinates: any[] = [];

    if (this.percent1 == true) {
      this.threadTrend.trend_data.params_list.forEach((v, index) => {
        ordinates.push({
          name: v,
          type: "line",
          data: this.threadTrend.trend_data.percent[index],
          smooth: true, // 平滑曲线
          symbol: "circle", //拐点设置为实心
          itemStyle: {
            normal: {
              label: {
                // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
                show: true,
              },
            },
          },
        });
      });
    } else {
      this.threadTrend.trend_data.params_list.forEach((v, index) => {
        ordinates.push({
          name: v,
          type: "line",
          data: this.threadTrend.trend_data.cost[index],
          smooth: true, // 平滑曲线
          symbol: "circle", //拐点设置为实心
          itemStyle: {
            normal: {
              label: {
                // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
                show: true,
              },
            },
          },
        });
      });
    }

    let performance_line: any = document.getElementById("thread");
    echarts.dispose(performance_line);
    let PerformanceLineChart = echarts.init(performance_line);
    PerformanceLineChart.on("click", (params) => {
      this.threadTabelLoading = true;
      this.threadCurrentPage = 1;
      this.thread_input = "";
      dispatchAndroidThreadProcessList(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        type: 2,
        search: params.seriesName,
        size: this.threadSize,
        page: this.threadCurrentPage,
      }).then((res) => {
        this.threadTabelLoading = false;
      });
    });
    let option;
    option = {
      title: {
        left: "center",
        textStyle: {
          fontSize: 16,
          fontWeight: "normal",
        },
      },
      tooltip: {
        trigger: "axis",
      },
      legend: {
        x: "center",
        y: "bottom",
        type: "scroll",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "20%",
        right: "4%",
        containLabel: true,
      },

      animation: false,
      series: ordinates,
      yAxis: {
        type: "value",
      },
      xAxis: {
        type: "category",
        data: this.threadTrend.trend_data.date,
      },
    };
    PerformanceLineChart.setOption(option);
  }

  public courseBtn() {
    this.percent = !this.percent;
    this.drawCourseTrend();
  }
  public threadBtn() {
    this.percent1 = !this.percent1;
    this.drawThreadTrend();
  }
  public getColor(item) {
    if (String(item)?.indexOf("↑") != -1) {
      return "#00b050";
    }
    if (String(item)?.indexOf("↓") != -1) {
      return "red";
    }
    if (item == 0) {
      return "#606266";
    }
  }
  public drawCourseTrend() {
    let ordinates: any[] = [];

    if (this.percent == true) {
      this.couseTrend.trend_data.params_list.forEach((v, index) => {
        ordinates.push({
          name: v,
          type: "line",
          data: this.couseTrend.trend_data.percent[index],
          smooth: true, // 平滑曲线
          symbol: "circle", //拐点设置为实心
          itemStyle: {
            normal: {
              label: {
                // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
                show: true,
              },
            },
          },
        });
      });
    } else {
      this.couseTrend.trend_data.params_list.forEach((v, index) => {
        ordinates.push({
          name: v,
          type: "line",
          data: this.couseTrend.trend_data.cost[index],
          smooth: true, // 平滑曲线
          symbol: "circle", //拐点设置为实心
          itemStyle: {
            normal: {
              label: {
                // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
                show: true,
              },
            },
          },
        });
      });
    }

    let performance_line: any = document.getElementById("course");
    echarts.dispose(performance_line);
    let PerformanceLineChart = echarts.init(performance_line);
    PerformanceLineChart.on("click", (params) => {
      this.courseTableLoading = true;
      this.courseCurrentPage = 1;
      this.course_input = "";
      dispatchAndroidCourseProcessList(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        type: 1,
        search: params.seriesName,
        size: this.courseSize,
        page: this.courseCurrentPage,
      }).then((res) => {
        this.courseTableLoading = false;
      });
    });
    let option;
    option = {
      title: {
        left: "center",
        textStyle: {
          fontSize: 16,
          fontWeight: "normal",
        },
      },
      tooltip: {
        trigger: "axis",
      },
      legend: {
        x: "center",
        y: "bottom",
        type: "scroll",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "20%",
        right: "4%",
        containLabel: true,
      },

      animation: false,
      series: ordinates,
      yAxis: {
        type: "value",
      },
      xAxis: {
        type: "category",
        data: this.couseTrend.trend_data.date,
      },
    };
    PerformanceLineChart.setOption(option);
  }

  public drawTrend() {
    let ordinates: any[] = [];
    this.lightPerfTrend.trend_data.device_list.forEach((v, index) => {
      ordinates.push({
        name: v,
        type: "line",
        data: this.lightPerfTrend.trend_data.series[index],
        smooth: true, // 平滑曲线
        symbol: "circle", //拐点设置为实心
        itemStyle: {
          normal: {
            label: {
              // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
              show: true,
            },
          },
        },
      });
    });
    let performance_line: any = document.getElementById("performance_line");
    echarts.dispose(performance_line);
    let PerformanceLineChart = echarts.init(performance_line);
    let option;
    option = {
      title: {
        left: "center",
        textStyle: {
          fontSize: 16,
          fontWeight: "normal",
        },
      },
      tooltip: {
        trigger: "axis",
        formatter: function (params) {
          //  只粘贴formatter了

          let relVal = params[0].axisValueLabel;
          for (let i = 0; i < params.length; i++) {
            relVal +=
              "<br />" +
              params[i].marker +
              params[i].seriesName +
              '<span style="font-weight:bold;float:right">' +
              (params[i].value == undefined ? "-" : params[i].value) + //   不同点
              "(Byte)" +
              "</span>";
          }

          return relVal;
        },
      },
      legend: {
        x: "center",
        y: "bottom",
        type: "scroll",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "20%",
        right: "4%",
        containLabel: true,
      },

      animation: false,
      series: ordinates,
      yAxis: {
        type: "value",
        axisLabel: {
          formatter: "{value}(Byte)",
        },
      },
      xAxis: {
        type: "category",
        data: this.lightPerfTrend.trend_data.date,
      },
    };
    PerformanceLineChart.setOption(option);
  }
}
